<template>
  <div id="app">
    <!--// 🔄 Watcher para manter SSO ativo durante navegação
watch(
  () => route.path,
  (newPath) => {
    // Se não está autenticado mas mudou de rota, verificar SSO
    // MAS NÃO durante logout (se indo para /login)
    if (!authStore.isAuthenticated && newPath !== '/login') {
      console.log('🔄 Route changed to:', newPath, '- checking SSO...')
      const restored = authStore.checkAndMaintainSSO()
      if (restored) {
        console.log('✅ SSO restored on route change')
      }
    } else if (newPath === '/login') {
      console.log('🚪 Going to login page - not restoring SSO')
    }
  },
  { immediate: false }
) while authentication is initializing -->
    <div
      v-if="!authStore.isInitialized"
      class="flex items-center justify-center min-h-screen bg-gray-50"
    >
      <div class="text-center">
        <div
          class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"
        ></div>
        <p class="text-gray-600">Carregando...</p>
      </div>
    </div>

    <!-- Main app content -->
    <router-view v-else />
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'

const route = useRoute()
const authStore = useAuthStore()
const appStore = useAppStore()

onMounted(() => {
  // Initialize app settings (auth is already initialized in main.ts)
  appStore.initDarkMode()
  appStore.initSidebar()
})

// 🔄 Watcher para manter SSO ativo durante navegação
watch(
  () => route.path,
  newPath => {
    // Se não está autenticado mas mudou de rota, verificar SSO
    // MAS NÃO durante logout (se indo para /login)
    if (!authStore.isAuthenticated && newPath !== '/login') {
      console.log('🔄 Route changed to:', newPath, '- checking SSO...')
      const restored = authStore.checkAndMaintainSSO()
      if (restored) {
        console.log('✅ SSO restored on route change')
      }
    } else if (newPath === '/login') {
      console.log('🚪 Going to login page - not restoring SSO')
    }
  },
  { immediate: false }
)

// 🔄 Monitorar mudanças no localStorage (caso outro popup/aba faça SSO)
onMounted(() => {
  window.addEventListener('storage', e => {
    if (e.key === 'sso_authenticated' && e.newValue === 'true') {
      console.log('🔄 SSO detected from another tab/popup')
      authStore.checkAndMaintainSSO()
    } else if (e.key === 'sso_authenticated' && e.newValue === null) {
      console.log('🚪 SSO cleared from another tab')
      // Se SSO foi limpo em outra aba, também limpar aqui
      // Mas não se foi logout explícito
      const isExplicitLogout = sessionStorage.getItem('explicit_logout') === 'true'
      if (
        authStore.isAuthenticated &&
        localStorage.getItem('sso_authenticated') !== 'true' &&
        !isExplicitLogout
      ) {
        authStore.signOut()
      }
    }
  })
})
</script>

<style>
#app {
  height: 100vh;
  overflow: hidden;
}
</style>
